import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { zArr, zNullable, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const CBMEngineDataState = z.object({
    dateLastOverhaul: ZDate,
    runningHours: zNum(),
    lastOverhaulHours: zNum(),
    nextOverhaulHours: zNum(),
    estimatedDateNextOverhaul: ZDate,
});
export const CBMEngineData = z.object({
    engineId: zNum(),
    engineLabel: zStr(),
    state: zNullable(CBMEngineDataState),
    runningHours: zNum(),
    averageLoadPercent: zNum(),
});
export var EngineType;
(function (EngineType) {
    EngineType["MAINENGINE"] = "mainEngine";
    EngineType["THRUSTER"] = "thruster";
})(EngineType || (EngineType = {}));
export const EngineTypeEnum = z.nativeEnum(EngineType);
export const CBMGetEnginesDataArgs = z.object({
    engineType: EngineTypeEnum,
    plantId: zNum(),
    interval: zObj({
        gt: ZDate,
        lt: ZDate,
    }),
    opModeId: zOptional(zNum())
});
export const CBMSetEngineParamsArgs = z.object({
    engineType: EngineTypeEnum,
    plantId: zNum(),
    engineId: zNum(),
    lastOverhaulDate: ZDate,
    lastOverhaulHours: zNum(),
    nextOverhaulHours: zNum(),
    currentRunningHours: zNum(),
    currentDate: ZDate,
});
export const CBMGetEnginePlotDataArgs = z.object({
    engineType: EngineTypeEnum,
    plantId: zNum(),
    engineId: zNum(),
    interval: zObj({
        gt: ZDate,
        lt: ZDate,
    }),
    opModeId: zOptional(zNum())
});
export const CBMLoadDistributionPlotEntry = z.object({
    loadPercentage: zNum(),
    percentageTimeInRange: zNum(),
    fuelConsumptionInGramsPerKwh: zNullable(zNum()),
    averageLoadInPercentage: zOptional(zNum()),
});
export const CBMEnginePerformanceSpecEntry = z.object({
    loadPercentage: zNum(),
    fuelConsumptionInGramsPerKwh: zNum(),
});
export const CBMLoadDistributionData = z.object({
    fuelConsumptionTimeElapsedByLoad: zArr(CBMLoadDistributionPlotEntry),
    engineSpecification: zNullable(zArr(CBMEnginePerformanceSpecEntry)),
});
export const CBMLoadPerModePlotEntry = z.object({
    opModeId: zNullable(zNum()),
    totalHours: zNum(),
    averageLoadPercent: zNum(),
    fuelConsumptionInGramsPerKwh: zOptional(zNum()),
});
export const CBMPercentageTimeInLoadThresholdedDataArgs = z.object({
    engineType: EngineTypeEnum,
    plantId: zNum(),
    enginesId: zArr(zNum()),
    thresholdPercentage: zNum(),
    opModeIds: zOptional(zArr(zNullable(zNum()))),
    interval: zObj({
        gt: ZDate,
        lt: ZDate,
    }),
});
export const PercentageTimeInLoadThresholdedData = z.object({
    opModeId: zOptional(zNullable(zNum())),
    percentageTimeAboveThreshold: zNum(),
});
export const CBMPercentageTimeInLoadThresholdedDataEntry = z.object({
    engineId: zNum(),
    data: zArr(PercentageTimeInLoadThresholdedData),
});
//# sourceMappingURL=conditionbasedmaintenance.js.map